<template>
  <div class="container">
    <div class="basic-settings-body">
      <div>
        <el-tabs v-model="activeMenu">
          <el-tab-pane label="平台课程授权" name="1">
            <el-table size="mini" :data="tableData" style="width: 100%">
              <el-table-column label="课程名称" width="300">
                <template slot-scope="scope">
                  <el-link @click="
                      UpdateCourseInfo(scope.row.id, scope.row.authInfo.price)
                    " type="primary">{{ scope.row.title }}</el-link>
                </template>
              </el-table-column>

              <el-table-column label="科目" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.subjectName }}</span>
                </template>
              </el-table-column>

              <el-table-column label="价格(单位:元)" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.authInfo.price }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="课程节数" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.number_of_courses }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="可授权教师数" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.authInfo.max_teacher_num }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="到期时间" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.authInfo.off_time }}</span>
                </template>
              </el-table-column>

              <el-table-column fixed="right" align="center" label="授权">
                <template slot-scope="scope">
                  <el-button @click="
                      CourseAuthor(
                        scope.row.title,
                        scope.row.id,
                        scope.row.authInfo.price
                      )
                    " size="mini" type="text">授权</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="自有课程授权" name="2">
            <el-table size="mini" :data="tableData" style="width: 100%">
              <el-table-column label="课程名称" width="300">
                <template slot-scope="scope">
                  <el-link @click="
                      UpdateCourseInfo(scope.row.id, scope.row.authInfo.price)
                    " type="primary">{{ scope.row.title }}</el-link>
                </template>
              </el-table-column>

              <el-table-column label="科目" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.subjectName }}</span>
                </template>
              </el-table-column>

              <el-table-column label="价格(单位:元)" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.authInfo.price }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="课程节数" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.number_of_courses }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="可授权教师数" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.authInfo.max_teacher_num }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="到期时间" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.authInfo.off_time }}</span>
                </template>
              </el-table-column>

              <el-table-column fixed="right" align="center" label="授权">
                <template slot-scope="scope">
                  <el-button @click="
                      CourseAuthor(
                        scope.row.title,
                        scope.row.id,
                        scope.row.authInfo.price
                      )
                    " size="mini" type="text">授权</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="收款账户授权" name="3">
            <div>
              <p class="create-campus">
                <el-button size="mini" type="primary" @click="createPayAccount">添加收款账户</el-button>
              </p>
              <div>
                <el-table size="mini" :data="PayAccountList" :header-cell-style="{ background: '#f5f7fa' }" style="width: 100%">
                  <el-table-column prop="name" label="账户名称"></el-table-column>

                  <el-table-column prop="campusNames" label="所属校区"></el-table-column>

                  <el-table-column prop="name" label="类型"></el-table-column>

                  <el-table-column prop="name" label="备注"></el-table-column>

                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="editAccount(scope.row)">编辑</el-button>
                      <el-button type="text" size="small" @click="deleteAccount(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="新建校区" :visible.sync="centerDialogVisible" width="50%">
      <el-form size="mini" :inline="true" class="form-style">
        <el-form-item label="校区名称：" required>
          <el-input v-model="educational_institution_campus_name" placeholder="请输入校区名称" style="width: 400px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="centerDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改校区名称" :visible.sync="editDialogVisible" width="50%" center>
      <el-form :inline="true" class="form-style">
        <el-form-item label="校区名称：" required>
          <el-input v-model="edit_educational_institution_campus_name" placeholder="请输入校区名称" style="width: 400px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editEducationalInstitutionCampusName">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog width="80%" :title="'授权课程: ' + current_coursetitle" :visible.sync="dialogTableVisible">
      <el-table size="mini" :data="SchoolAutherData" style="width: 100%" max-height="250">
        <el-table-column fixed prop="name" label="校区名称" width="150">
        </el-table-column>

        <el-table-column prop="course_num" label="已授权教师数">
        </el-table-column>

        <el-table-column prop="province" label="授权价格(单位:元)">
          <template slot-scope="scope">
            <span v-if="scope.row.campusAuth">{{
              scope.row.campusAuth.price
            }}</span>
          </template>
        </el-table-column>

        <el-table-column label="授权状态">
          <template slot-scope="scope">
            <span v-if="scope.row.campusAuth">已授权</span>
            <span v-else>未授权</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-popconfirm v-if="scope.row.campusAuth" title="确定要取消该校区的课程授权吗?" @onConfirm="addOrDeleteCurriculumAuth('2', scope.row.id)">
              <el-button slot="reference" type="text" size="small">
                取消授权
              </el-button>
            </el-popconfirm>

            <el-button v-if="!scope.row.campusAuth" @click="addOrDeleteCurriculumAuth('1', scope.row.id)" type="text" size="small">
              授权
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!--修改课程价格-->
    <el-dialog title="修改价格" :visible.sync="dialogFormVisible">
      <el-form size="mini" :model="form">
        <el-form-item label="课程价格(单位:元)">
          <el-input v-model="form.curriculum_price" placeholder="请输入课程价格"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="updateSchoolCurriculumPermissionPrice">确 定</el-button>
      </div>
    </el-dialog>

    <!--修改课程授权价格-->
    <el-dialog title="设置授权价格" :visible.sync="dialogFormVisible1">
      <el-form size="mini">
        <el-form-item label="课程价格(单位:元)">
          <el-input v-model="author_price" placeholder="请输入课程的授权价格"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="addOrDeleteCampusCurriculumAuth('1')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addEducationalInstitutionCampus,
  getEducationalInstitutionCampusList,
  editEducationalInstitutionCampusName,
  deleteEducationalInstitutionCampus,
  getBaseInfo,
  addStopDay,
  addClassDay,
  updateIsEncryption,
  getSchoolCurriculumList,
  getSchoolCampusCurriculumAuthData,
  updateSchoolCurriculumPermissionPrice,
  addOrDeleteCampusCurriculumAuth,
  getEducationalInstitutionAccountList,
} from "@/api/educational";
import { formatMinutes } from "@/config/_filter";
export default {
  name: "admin-authorize-settings",
  data() {
    return {
      //更新课程体系价格
      form: {
        curriculum_id: "",
        curriculum_price: "0",
      },

      form2: {
        educational_institution_campus_id: "",
        curriculum_id: "",
        price: "",
      },

      //校区课程体系权限详情
      SchoolAutherData: [],
      author_price: "",

      //修改课程价格
      dialogFormVisible: false,
      dialogFormVisible1: false,

      //授权课程title
      current_coursetitle: "",

      data: [
        {
          key: 1,
          label: "河西分校河西分校河西分校",
          price: "3699",
        },
        {
          key: 2,
          label: "津南分校",
          price: "1699",
        },
      ],
      value: [],

      tableName: [], //数据表名
      transferData: [], //Transfer 的数据源	array[{ key, label, disabled }]
      checked: [], //穿梭框绑定的数据，选定到右侧框中的数据项的value组成的数组

      dialogTableVisible: false,
      tableData: [
        {
          name: "Jrcode体验课",
          name1: "jrcode",
          price: "3699",
          num: "32",
        },
      ],
      campusTableData: [],
      centerDialogVisible: false,
      editDialogVisible: false,
      educational_institution_campus_name: "",
      edit_educational_institution_campus_name: "",
      edit_id: "",
      editableTabsValue: "1",
      editStopDayShow: false,
      educational_institution_closing_day_list: [
        {
          closing_date: "",
          name: "",
        },
      ],
      educational_institution_class_day_list: [],
      is_encryption: false,
      classtime: [formatMinutes(), formatMinutes()],

      //校区账户列表
      PayAccountList: [],

      activeMenu: "1", //激活的菜单
    };
  },
  mounted() {
    this.getEducationalInstitutionCampusList();
    this.getBaseInfo();
    this.getSchoolCurriculumList();
    this.getEducationalInstitutionAccountList();

    if (this.$route.query.activeMenu) {
      this.activeMenu = this.$route.query.activeMenu; //动态激活菜单
    }

    console.log("this.generateData");
    console.log(this.generateData);
  },
  watch: {},
  methods: {
    //课程授权

    CourseAuthor(title, id, price) {
      this.dialogTableVisible = true;
      this.current_coursetitle = title;
      this.form2.curriculum_id = id;
      this.author_price = price;

      this.getSchoolCampusCurriculumAuthData(id);
    },

    //授权或取消授权操作
    addOrDeleteCurriculumAuth(cmd, id) {
      if (cmd == "1") {
        console.log("授权操作");
        this.form2.educational_institution_campus_id = id;
        this.dialogFormVisible1 = true;
      } else {
        console.log("取消授权");
        this.form2.educational_institution_campus_id = id;
        this.addOrDeleteCampusCurriculumAuth("2");
      }
    },

    //授权课程给校区
    addOrDeleteCampusCurriculumAuth(operate) {
      addOrDeleteCampusCurriculumAuth({
        educational_institution_campus_id: this.form2
          .educational_institution_campus_id,
        curriculum_id: this.form2.curriculum_id,
        price: this.author_price,
        operate: operate, //1添加  2删除
      }).then((res) => {
        console.log("授权课程");
        console.log(res);
        if (res.is_create) {
          this.getSchoolCampusCurriculumAuthData(this.form2.curriculum_id);
          this.dialogFormVisible1 = false;
          this.$message.success("授权成功");
        }

        if (res.is_delete) {
          this.getSchoolCampusCurriculumAuthData(this.form2.curriculum_id);
          this.$message.success("取消授权成功");
        }
      });
    },

    //查询校区账户列表
    getEducationalInstitutionAccountList() {
      getEducationalInstitutionAccountList({
        name: "",
        page_no: "1",
        page_size: "100",
      }).then((res) => {
        console.log("查询校区账户列表");
        console.log(res);
        this.PayAccountList = res.educationalinstitutionaccountList;
      });
    },

    //根据数据表名，从后台获取各个表的所有字段的相关信息
    fetchData() {
      this.$store
        .dispatch("getTableColumnInfo", this.tableName)
        .then((res) => {
          if (res.data.code == 1) {
            const allData = res.data.data;
            const data = [];
            for (let i = 0; i < allData.length; i++) {
              data.push({
                key: allData[i].rownum,
                label: allData[i].name,
                comment: allData[i].comment,
                tabname: allData[i].tabname,
              });
            }
            this.transferData = data;
          } else {
            this.$message.error("表字段查询失败");
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },

    //右侧列表元素变化时触发
    getObject() {
      console.log("选中所有数据" + this.checked);
    },

    submitClassDay(index) {
      if (!this.classtime.length) {
        this.$message.warning("请选择时间");
        return;
      }
      this.educational_institution_class_day_list[
        index
      ].start_class_date = this.classtime[0];
      this.educational_institution_class_day_list[
        index
      ].end_class_date = this.classtime[1];
      this.addClassDay("保存成功", "update", index);
    },
    addClassDay(msg, status, index) {
      let class_day_list = this.educational_institution_class_day_list.map(
        (item) => {
          return {
            start: "2020-02-02 " + item.start_class_date,
            end: "2020-02-02 " + item.end_class_date,
          };
        }
      );
      addClassDay({
        class_day_list: JSON.stringify(class_day_list),
      }).then(() => {
        if (status === "update") {
          this.educational_institution_class_day_list[index].edit = false;
          this.classtime = [formatMinutes(), formatMinutes()];
          console.log(this.classtime);
        }
        this.$message.success(msg);
      });
    },
    deleteClassDay(index) {
      this.$confirm("确定删除当前授课时段?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.educational_institution_class_day_list.splice(index, 1);
        this.addClassDay("删除成功");
      });
    },
    closeUpdateClassTime(index) {
      this.$set(
        this.educational_institution_class_day_list[index],
        "edit",
        false
      );
    },
    updateClassTime(index) {
      this.$set(
        this.educational_institution_class_day_list[index],
        "edit",
        true
      );
      this.classtime = [
        this.educational_institution_class_day_list[index].start_class_date,
        this.educational_institution_class_day_list[index].end_class_date,
      ];
    },
    addClassTime() {
      this.educational_institution_class_day_list.unshift({
        start_class_date: "",
        end_class_date: "",
        edit: true,
      });
    },
    updateIsEncryption() {
      updateIsEncryption({
        is_encryption: this.is_encryption,
      }).then(() => {
        this.$message.success("修改成功");
      });
    },

    //获得校区的课程体系列表

    getSchoolCurriculumList() {
      getSchoolCurriculumList({}).then((res) => {
        console.log("查询校区课程体系");
        console.log(res);

        this.tableData = res.curriculumList;
      });
    },

    //获得课程体系的授权信息
    getSchoolCampusCurriculumAuthData(id) {
      getSchoolCampusCurriculumAuthData({
        curriculum_id: id,
      }).then((res) => {
        console.log("查询课程体系的授权信息");
        console.log(res);
        // this.tableData = res.curriculumList;
        this.SchoolAutherData = res.schoolCampusList;
      });
    },

    UpdateCourseInfo(id, price) {
      this.dialogFormVisible = true;
      this.form.curriculum_id = id;
      this.form.curriculum_price = price;
    },

    //更新校区课程体系默认价格
    updateSchoolCurriculumPermissionPrice() {
      console.log(this.form);

      updateSchoolCurriculumPermissionPrice({
        curriculum_id: this.form.curriculum_id,
        price: this.form.curriculum_price,
      }).then((res) => {
        console.log("更新课程体系价格");
        console.log(res);

        if (res.is_update) {
          this.dialogFormVisible = false;
          this.$message.success("价格设置成功");
          this.getSchoolCurriculumList();
        }
      });
    },

    saveStopDay() {
      for (
        let i = 0;
        i < this.educational_institution_closing_day_list.length;
        i++
      ) {
        if (
          !this.educational_institution_closing_day_list[i].closing_date ||
          !this.educational_institution_closing_day_list[i].name
        ) {
          this.$message.warning("请填写日期或名称");
          return;
        }
      }
      let closing_day_list = this.educational_institution_closing_day_list.map(
        (item) => {
          return {
            date: item.closing_date,
            name: item.name,
          };
        }
      );
      addStopDay({
        closing_day_list: JSON.stringify(closing_day_list),
      }).then(() => {
        this.$message.success("保存成功");
        this.editStopDayShow = false;
      });
    },
    reduceStopDay(index) {
      this.educational_institution_closing_day_list.splice(index, 1);
    },
    addStopDay() {
      this.educational_institution_closing_day_list.push({
        closing_date: "",
        name: "",
      });
    },
    getBaseInfo() {
      getBaseInfo().then((res) => {
        this.educational_institution_closing_day_list =
          res.educational_institution_closing_day_list;
        this.educational_institution_class_day_list =
          res.educational_institution_class_day_list;
        this.is_encryption = res.educational_institution_obj[0].is_encryption;
      });
    },
    deleteCampus(row) {
      this.$confirm("确定删除当前校区?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteEducationalInstitutionCampus({
          educational_institution_campus_id: row.id,
        }).then(() => {
          this.$message.success("删除校区成功！");
          this.getEducationalInstitutionCampusList();
        });
      });
    },
    editName(row) {
      this.edit_educational_institution_campus_name = row.name;
      this.edit_id = row.id;
      this.editDialogVisible = true;
    },

    editAccount(row) {
      this.$router.push({
        name: "payaccount",
        query: {
          cmd: "edit",
          account: row,
        },
      });
    },

    editEducationalInstitutionCampusName() {
      editEducationalInstitutionCampusName({
        educational_institution_campus_id: this.edit_id,
        educational_institution_campus_name: this
          .edit_educational_institution_campus_name,
      }).then(() => {
        this.$message.success("修改校区名称成功！");
        this.editDialogVisible = false;
        this.getEducationalInstitutionCampusList();
      });
    },
    createCampus() {
      this.centerDialogVisible = true;
    },

    createPayAccount() {
      this.$router.push({
        name: "payaccount",
        query: {
          cmd: "create",
        },
      });
    },

    getEducationalInstitutionCampusList() {
      getEducationalInstitutionCampusList().then((res) => {
        this.campusTableData = res.educational_institution_campus_list;
      });
    },
    save() {
      addEducationalInstitutionCampus({
        name: this
          .educational_institution_campus_name,
      }).then(() => {
        this.$message.success("新建校区成功！");
        this.centerDialogVisible = false;
        this.educational_institution_campus_name = "";
        this.getEducationalInstitutionCampusList();
      });
    },

    //穿梭框
    handleChange(value, direction, movedKeys) {
      console.log(value, direction, movedKeys);

      console.log(value);
      console.log(direction);
      console.log(movedKeys);

      this.$message("授权成功");
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  overflow: hidden;

  .basic-settings-body {
    margin: 15px;
    padding: 15px;
    background-color: #ffffff;
    border-radius: 5px;
    .create-campus {
      padding: 10px 0;
    }
  }
  .editStopDayShow {
    padding: 1 5px 0;
  }

  .transfer-footer {
    margin-left: 20px;
    padding: 6px 5px;
  }
}
</style>

<style>
.el-transfer-panel {
  width: 40%;
}
</style>

